import React, { useState, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Cookie from 'utils/cookies';
import V4VideoPlayer from 'components/Video/V4VideoLoaderListing';
import s from './LiveTvEntryWidget.scss';
// eslint-disable-next-line import/first
import AdCaller from 'helpers/ads/adCaller';

import { TOI_LIVE_DOMAIN } from '../../../../../constants';

import InterSectionBorder from '../../../../../components_v2/common/InterSectionBorder/InterSectionBorder';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';
import InViewObserver from '../../../../../components/InViewObserver/InViewObserver';
import Morebtn from '../../../../../components_v2/desktop/Morebtn';
import Listingheader from '../ListingheaderV2';
import HeaderTab from '../../desktop/HeaderTabV2/HeaderTab';

let liveTvWidgetPositionCounter = 0;

const LiveTvEntry = ({ sectionData, ga4Type, ga4Label, ga4Category }) => {
  // Get children array from sectionData
  const children = sectionData?.items?.[0]?.children || [];

  // Stable global player id per widget instance
  const widgetPositionRef = useRef(0);
  if (!widgetPositionRef.current) {
    liveTvWidgetPositionCounter += 1;
    widgetPositionRef.current = liveTvWidgetPositionCounter;
  }
  const globalRefIdRef = useRef(
    `lg_videowidget_livestream_${widgetPositionRef.current}`,
  );
  const playerContainerIdRef = useRef(
    `lg_player_id_livestream_${widgetPositionRef.current}`,
  );

  // Create subSections array from children titles for HeaderTab
  const subSections = useMemo(
    () => {
      if (!children || children.length === 0) return [];
      return children.map((child, index) => ({
        name: child.title || `Tab ${index + 1}`,
        id: child.msid || `tab-${index}`,
        active: index === 0, // First tab is active by default
        childData: child, // Store child data for reference
      }));
    },
    [children],
  );

  // State to track active tab index (0 for first video)
  const [activeIndex, setActiveIndex] = useState(0);
  // Track a changing key to force a fresh player mount per tab change
  const [videoKey, setVideoKey] = useState(0);
  const prevActiveIndexRef = useRef(0);

  // Get active video based on activeIndex
  const activeVideo = useMemo(
    () => {
      if (children && children.length > 0 && children[activeIndex]) {
        return children[activeIndex];
      }
      return null;
    },
    [children, activeIndex],
  );

  const grxId = Cookie?.get('_grx') || '';

  // Handle tab change - similar to VideoLayoutV2
  const onTabsChange = params => {
    const clickedItem = params?.clickedItem;
    if (clickedItem) {
      // Try to find by childData first, then by id, then by name
      let newIndex = -1;

      if (clickedItem.childData && clickedItem.childData.msid) {
        newIndex = children.findIndex(
          child => child.msid === clickedItem.childData.msid,
        );
      } else if (clickedItem.id) {
        // Find by msid from the id
        newIndex = children.findIndex(child => child.msid === clickedItem.id);
      } else if (clickedItem.name) {
        // Find by title
        newIndex = children.findIndex(
          child => child.title === clickedItem.name,
        );
      }

      if (newIndex !== -1 && newIndex !== activeIndex) {
        // Destroy current player before switching tabs (similar to VideoLayoutV2)
        if (
          window &&
          window?.lwPlayer &&
          window?.lwPlayer[globalRefIdRef?.current]
        ) {
          try {
            window.lwPlayer[globalRefIdRef.current].destroy();
          } catch (error) {
            console.error('Error destroying player:', error);
          }
        }

        // Update active index - this will cause React to remount with new video
        // The new video will autoplay because autoplay prop is always true
        setActiveIndex(newIndex);
        setVideoKey(prev => prev + 1);
        prevActiveIndexRef.current = newIndex;
      }
    }
  };

  return (
    <>
      <InViewObserver
        inViewCallback={() =>
          analyticsWrapper('ga4', {
            event: 'user_shown',
            type: ga4Type || '',
            label: ga4Label || '',
            category: ga4Category || '',
            user_grx_id: grxId,
          })
        }
      >
        {sectionData?.border === 'top' && (
          <InterSectionBorder border={sectionData?.border} />
        )}
        <div className={s.liveTvEntryWidget}>
          <div className={s.title}>
            <Listingheader
              headingname={sectionData?.name}
              headingLink={`${TOI_LIVE_DOMAIN}${sectionData?.path ||
                '/live-tv'}`}
              marginBottomZero
              liveBlinker
              ga4Type={ga4Type || ''}
              ga4Category={ga4Category || ''}
              ga4Label={ga4Label || ''}
            />
            {/* <div className={s.sponserBy}> */}
            {/* <span>Sponsored By</span>
              <img
                src="https://static.toiimg.com/photo/126671281.cms"
                alt="Sponsored By"
              /> */}
            <AdCaller
              data={{ jname: 'liveTvSponser' }}
              adWapperClass={s.sponserBy}
            />
            {/* </div> */}
          </div>

          <div className={s.tabContainer}>
            {subSections.length > 0 && (
              <HeaderTab
                subSections={subSections}
                onChangeCallback={onTabsChange}
                newga="Cartoon_Actions_TabChange#Click_"
                ga4Type={ga4Type || ''}
                ga4Category="tab_change"
                itemScrollable
                itemGap12
                fontLarge
                itemColorGrey
                activeItemBold
              />
            )}
          </div>
          <div className={s.liveTvStream}>
            <div className={s.item}>
              <div className={s.simulator}>
                {activeVideo && (
                  <V4VideoPlayer
                    key={`livetv-video-${
                      activeVideo.msid
                    }-${activeIndex}-${videoKey}`}
                    tmplSource="listing"
                    msid={activeVideo.msid}
                    videoClassName="phShimmer"
                    // videoClassName={s.backgroundVideoImage}
                    videoClassInner={s.player_container_wrap}
                    autoplay
                    slikeNextVideoAutoPlayed={false}
                    // store={store}
                    allowDim={false}
                    slikeId={activeVideo.slikeId}
                    playerType="24"
                    globalRefId={`${globalRefIdRef.current}_${videoKey}`}
                    playerContainerId={`${
                      playerContainerIdRef.current
                    }_${videoKey}`}
                    isUserPrime={false}
                    source="USNHP_MainVideoWidget"
                    gestureControls
                    // outsideEventListener={videoEventListener}
                    shareUrl={
                      activeVideo?.canonicalURL || `${TOI_LIVE_DOMAIN}/live-tv`
                    }
                    isVideoSkipAds={false}
                    metakeywords="Entertainment"
                    newGamAdSection="widget_hp"
                  />
                )}
              </div>
            </div>
            <Morebtn
              moreLink={activeVideo?.canonicalURL || '/live-tv'}
              moreText="Stream Now"
              noArrow
              redbg
              fullWidth
              ga4Data={[
                {
                  event: 'user_click',
                  type: ga4Type || '',
                  label: ga4Label || '',
                  category: ga4Category || '',
                },
              ]}
            />
          </div>
        </div>
        {sectionData?.border === 'bottom' && (
          <InterSectionBorder border={sectionData?.border} />
        )}
      </InViewObserver>
    </>
  );
};

const mapStateToProps = state => ({
  userData: state.login.userData,
});

LiveTvEntry.propTypes = {
  sectionData: PropTypes.shape({
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    id: PropTypes.string,
    border: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        children: PropTypes.arrayOf(
          PropTypes.shape({
            title: PropTypes.string,
            msid: PropTypes.string,
            slikeId: PropTypes.string,
            canonicalURL: PropTypes.string,
          }),
        ),
      }),
    ),
    subSections: PropTypes.shape({ dataUrl: PropTypes.string }),
  }),
  userData: PropTypes.shape({}),
  ga4Type: PropTypes.string,
  ga4Label: PropTypes.string,
  ga4Category: PropTypes.string,
};

LiveTvEntry.defaultProps = {
  sectionData: {},
  userData: {},
  ga4Type: '',
  ga4Label: '',
  ga4Category: '',
};

export default connect(mapStateToProps, null)(LiveTvEntry);
